__turbopack_context__.v({
  "articles": "_N8Ddq_articles",
  "card": "_N8Ddq_card",
  "container": "_N8Ddq_container",
  "filters": "_N8Ddq_filters",
  "jump": "_N8Ddq_jump",
  "leaderboardDisabled": "_N8Ddq_leaderboardDisabled",
  "title": "_N8Ddq_title",
  "topline": "_N8Ddq_topline",
  "variant--standard": "_N8Ddq_variant--standard",
  "variant--wideCard": "_N8Ddq_variant--wideCard",
});
